document.addEventListener("DOMContentLoaded", function () {
  const industryFilters = document.getElementsByClassName('js-blog-tag--industry');
  enableFilters(industryFilters, "industryTags");

  const solutionFilters = document.getElementsByClassName('js-blog-tag--solution');
  enableFilters(solutionFilters, "solutionTags");
});

function enableFilters(filters, paramName) {
  if (filters) {
    for (let i = 0; i < filters.length; i++) {
      const filter = filters[i];
      filter.addEventListener('click', function (e) {
        toggleFilter(filter, e, paramName);
      });
    }
  }
}

function toggleFilter(filter, e, paramName) {
  if (e.pointerId >= 0) {
    const pageUrl = window.location.href.replace(location.search, "");
    const urlParams = new URLSearchParams(location.search);
    const checkbox = filter.querySelector('input[type="checkbox"]');
    if (checkbox.checked) {
      deactivateFilter(paramName, checkbox.value.toString(), pageUrl, urlParams);
    } else {
      activateFilter(paramName, checkbox.value.toString(), pageUrl, urlParams);
    }
  }
}

function activateFilter(paramName, tag, pageUrl, urlParams) {
  const currentTags = urlParams.get(paramName);
  if (!currentTags) {
    urlParams.append(paramName, tag);
  }
  else {
    const tags = currentTags.split(",");
    if (!tags.includes(tag)) {
      tags.push(tag);
    }
    const updatedTags = tags.join(",");
    urlParams.set(paramName, updatedTags);
  }
  window.location.assign(`${pageUrl}?${urlParams.toString()}`);
}

function deactivateFilter(paramName, tag, pageUrl, urlParams) {
  const currentTags = urlParams.get(paramName);
  if (currentTags) {
    let tags = currentTags.split(",");
    if (tags.includes(tag)) {
      tags = tags.filter(x => x !== tag);
    }
    const updatedTags = tags.join(",");
    if (!updatedTags || updatedTags.length <= 0) {
      urlParams.delete(paramName);
    } else {
      urlParams.set(paramName, updatedTags);
    }

    const urlParamString = urlParams.toString();
    if (urlParamString && urlParamString.length > 0) {
      window.location.assign(`${pageUrl}?${urlParams.toString()}`);
    } else {
      window.location.assign(pageUrl);
    }
  }
}